export const iconFontAwesomeMapsThumbtack = (
	<i className="fa-solid fa-thumbtack"></i>
);
